import _property from 'lodash/property';

var expenseAllocationEntries = _property('allocationEntries');

var distributionAllocationEntries = _property('expenseAllocationEntries');

var allocationEntriesCount = _property('allocationEntriesCount');

var allocationParameter = _property('allocationParameter');

var createdByUserId = _property('createdByUserId');

var createdTime = _property('createdTime');

var dealerId = _property('dealerId');

var description = _property('description');

var franchiseId = _property('franchiseId');

var glAccountId = _property('glAccountId');

var distributionKey = _property('distributionKey');

var id = _property('id');

var modifiedByUserId = _property('modifiedByUserId');

var modifiedTime = _property('modifiedTime');

var allocationType = _property('expenseAllocationType');

var READER = {
  expenseAllocationEntries: expenseAllocationEntries,
  distributionAllocationEntries: distributionAllocationEntries,
  allocationEntriesCount: allocationEntriesCount,
  allocationParameter: allocationParameter,
  createdByUserId: createdByUserId,
  createdTime: createdTime,
  dealerId: dealerId,
  description: description,
  franchiseId: franchiseId,
  glAccountId: glAccountId,
  distributionKey: distributionKey,
  id: id,
  modifiedByUserId: modifiedByUserId,
  modifiedTime: modifiedTime,
  allocationType: allocationType
};
export default READER;